<template>
    <v-card v-if="terms">
        <v-card-title>{{ terms.title }}</v-card-title>
        <v-card-text v-html="terms.content">
        </v-card-text>
    </v-card>
</template>

<script>

export default {
    name: "TermsOfUse",
    computed:{
        terms(){
            const terms = this.$store.state.resources.policy_and_terms.terms_and_conditions;
            terms.content = terms.content.replaceAll('\\r','').replaceAll('\\n','');
            return terms;
        },
    }
}
</script>
